<template>
  <div class="chart chart-move">
    <!-- <v-layout  v-if="editMode" class="chart-tool">
      <v-flex row>
        <v-spacer/>
        <v-btn flat icon dark slot="activator" v-scroll-to="'#down'" @click="$emit('duplicate-chart', slice)">
          <v-tooltip bottom>
            <v-icon small slot="activator">file_copy</v-icon>
            <span>Duplicate Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat icon dark slot="activator" @click="$emit('edit-chart', chartId)">
          <v-tooltip bottom>
            <v-icon small slot="activator">build</v-icon>
            <span>Edit Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat icon dark slot="activator" @click="$emit('deleteChart', chartId)">
          <v-tooltip bottom>
            <v-icon small slot="activator">remove_circle_outline</v-icon>
            <span>Delete Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout> -->
    <v-layout v-if="editMode" class="chart-tool" >
      <v-spacer />
      <v-menu
        transition="slide-y-transition"
        offset-y
        :close-on-content-click="false"
      >
          <template v-slot:activator="{ on }">
            <v-btn dark icon v-on="on" style="outline: none;" @click="action">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-tile @click="$emit('duplicate-chart', slice)" v-scroll-to="'#down'">
              <v-icon size="16" style="color: #757575;">file_copy</v-icon>
              <v-list-tile-title style=" margin-left: 5px; color: #757575;">Duplicate</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('edit-chart', chartId)" >
              <v-icon size="16" style="color: #757575;">build</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Edit</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('deleteChart', chartId)" >
              <v-icon size="16" style="color: #757575;">remove_circle_outline</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Delete</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
    </v-layout>
    <v-layout v-else-if="previewMode === true" mx-0 my-1>
    </v-layout>
    <v-layout v-else class="extand-chart" >
      <v-flex row >
        <v-spacer></v-spacer>
        <v-btn
          flat
          icon
          dark
          style="outline: none;"
          slot="activator"
          class="btn-zoom-chart"
          @click="$emit('full-chart', chartId)"
        >
          <v-tooltip bottom>
            <v-icon slot="activator">zoom_in</v-icon>
            <span>Full Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-chart
      ref="options"
      :init-Options="initOptions"
      :options="options"
      :autoresize="true"
      :style="{ height, width }"
      @init="initChart"
      @click="handleChartClick"/>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/map'
import 'echarts/lib/component/visualMap'
import 'echarts/map/js/world'
import axios from 'axios'
import echarts from 'echarts'

export default {
  name: 'TimeBar',
  components: {
    'v-chart': ECharts
  },
  props: {
    text: {
      type: String
    },
    className: {
      type: String,
      default: 'chart'
    },
    user_index: {
      type: String
    },
    user_inst: {
      type: String
    },
    startTime: {
      type: [String, Number]
    },
    endTime: {
      type: [String, Number]
    },
    intervalTimeBar: {
      type: String
    },
    interval: {
      type: String,
      default: '1m'
    },
    stores: {
      type: Array
    },
    subFilter: {
      type: String
    },
    valid: {
      type: Boolean
    },
    chartId: {
      type: String
    },
    chartName: {
      type: String,
      default: 'Untitle'
    },
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: '90%'
    },
    bar_line: {
      type: String,
      default: 'bar'
    },
    editMode: {
      type: Boolean,
      default: false
    },
    slice: {
      type: [Object]
    },
    index_now: {
      type: String
    },
    previewMode: {
      type: Boolean,
      default: false
    },
    reloadchart: {
      type: Boolean,
      default: false
    }
  },
    data () {
      return {
        initOptions: {renderer: 'canvas'},
        x: [],
        y: [],
        options: {},
        newtime: '',
        time: '',
        intervals: '',
        // interval: '',
        sub: ''
      }
    },
   async created () {
      if (this.intervalTimeBar === 'auto') {
        this.interval = this.interval
      } else {
        this.interval = this.intervalTimeBar
      }
      if (this.user_index === undefined) {
        this.user_index = this.index_now
      }
    },
  async mounted () {
    await this.initChart()
    await this.beforeload()
  },
    methods: {
      async initChart () {
        this.$refs.options.showLoading({
          color: '#4ea397',
          maskColor: 'transparent',
          textColor: '#ccc'
        })
        if (this.subFilter !== '*' && this.text !== '') {
          this.sub = ''
          this.sub = `${this.subFilter} AND ${this.text}`
        } else if (this.subFilter !== '*') {
          this.sub = ''
          this.sub = `${this.subFilter}`
        } else {
        }
        let options = {
          title: {
            show: true,
            text: this.chartName,
            textStyle: {
              color: '#ccc',
              fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
            }
          },
          backgroundColor: 'transparent',
          series: []
        }
        let response = await axios.post(apiUrl + '/api/query/histogram', {
          start: this.startTime,
          end: this.endTime,
          instance: this.user_inst,
          index: this.user_index,
          interval: this.interval,
          stores: this.stores,
          sub: this.sub,
          text: this.text
        })
        // console.log('timebar')
        // console.log(response.data)
        this.$refs.options.hideLoading()
        this.x = []
        this.y = []
        // if (response.data.msg) {
        //   this.options = Object.assign({}, options, {
        //     graphic: {
        //       type: 'text',
        //       left: 'center',
        //       top: 'middle',
        //       style: {
        //         text: 'Request time out.',
        //         font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
        //         fill: '#ccc'
        //       }
        //     }
        //   })
        //   return
        // }
        this.options = {}
        if (response.data.length !== 0) {
          // Still not work
          for (let data of response.data) {
            let date = ''
            let time = ''
            let formatTime = ''
            date = new Date(data.key).toDateString()
            time = new Date(data.key).toLocaleTimeString()
            formatTime = date + ' ' + time
            this.x.push(formatTime)
            this.y.push(data.doc_count)
          }
          this.options = Object.assign({}, options, {
            grid: {
              top: 35,
              left: '5%',
              right: '5%',
              bottom: '3%',
              containLabel: true
            },
            // toolbox: {
            //   show: true,
            //   orient: 'horizontal',
            //   itemSize: 18,
            //   itemGap: 20,
            //   right: 20,
            //   feature: {
            //     saveAsImage: {
            //       show: true,
            //       title: 'save as image'
            //     }
            //   }
            // },
            xAxis: [{
              type: 'category',
              data: this.x,
              axisTick: {
                alignWithLabel: true
              },
              axisLine: {
                lineStyle: {
                  color: 'white'
                }
              }
            }],
            yAxis: [{
              type: 'value',
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  color: 'white'
                }
              }
            }],
            series: [{
              name: 'count',
              type: this.bar_line,
              barWidth: '60%',
              data: this.y,
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#83bff6'
                  }, {
                    offset: 0.5,
                    color: '#188df0'
                  }, {
                    offset: 1,
                    color: '#188df0'
                  }])
                },
                emphasis: {
                  label: {
                    show: true,
                    formatter: '{b}: {c}'
                  },
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#2378f7'
                  }, {
                    offset: 0.7,
                    color: '#2378f7'
                  }, {
                    offset: 1,
                    color: '#83bff6'
                  }])
                }
              }
            }]
          })
        } else {
          this.options = Object.assign({}, options, {
            graphic: {
              type: 'text',
              left: 'center',
              top: 'middle',
              style: {
                text: 'No data',
                font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
                fill: '#ccc'
              }
            }
          })
        }
      },
      beforeload () {
        this.$emit('loadChart', 'load', 'x-tbar')
      },
      handleChartClick (param) {
        // console.log(new Date(param.name).getTime())
        // console.log(this.interval)
        // console.log(this.intervalTimeBar)
        if (this.intervalTimeBar === 'auto') {
          this.interval = this.interval
          // alert(this.interval)
        } else {
          // alert(this.intervalTimeBar)
          this.interval = this.intervalTimeBar
          // alert(this.interval)
        }
        let intervalRange = this.interval === '10s'
          ? {
            start: new Date(param.name).getTime(),
            end: new Date(param.name).getTime() + 10000,
            interval: '1s'
          }
          : this.interval === '30s'
            ? {
              start: new Date(param.name).getTime(),
              end: new Date(param.name).getTime() + 30000,
              interval: '10s'
            }
            : this.interval === '1m'
              ? {
                start: new Date(param.name).getTime(),
                end: new Date(param.name).getTime() + 60000,
                interval: '30s'
              }
              : this.interval === '10m'
                ? {
                  start: new Date(param.name).getTime(),
                  end: new Date(param.name).getTime() + 600000,
                  interval: '1m'
                }
                : this.interval === '30m'
                  ? {
                    start: new Date(param.name).getTime(),
                    end: new Date(param.name).getTime() + 1800000,
                    interval: '1m'
                  }
                  : this.interval === '1h'
                    ? {
                      start: new Date(param.name).getTime(),
                      end: new Date(param.name).getTime() + 3600000,
                      interval: '30m'
                    }
                    : this.interval === '3h'
                      ? {
                        start: new Date(param.name).getTime(),
                        end: new Date(param.name).getTime() + 10800000,
                        interval: '30m'
                      }
                      : this.interval === '12h'
                        ? {
                          start: new Date(param.name).getTime(),
                          end: new Date(param.name).getTime() + 43200000,
                          interval: '3h'
                        }
                        : this.interval === '1d'
                          ? {
                            start: new Date(param.name).getTime(),
                            end: new Date(param.name).getTime() + 86400000,
                            interval: '12h'
                          }
                          : this.interval === '1w'
                            ? {
                              start: new Date(param.name).getTime(),
                              end: new Date(param.name).getTime() + 604800000,
                              interval: '1d'
                            }
                            : this.interval === '1M'
                              ? {
                                start: new Date(param.name).getTime(),
                                end: new Date(param.name).getTime() + 2629746000,
                                interval: '1w'
                              }
                              : this.interval === '1y'
                                ? {
                                  start: new Date(param.name).getTime(),
                                  end: new Date(param.name).getTime() + 31556952000,
                                  interval: '1M'
                                }
                                : {
                                  start: new Date(param.name).getTime(),
                                  end: new Date(param.name).getTime() + 10000,
                                  interval: '1s'
                                }
        let timeSt = intervalRange.start
        let timeEn = intervalRange.end
        let timeInt = intervalRange.interval
        // console.log(typeof (timeSt))
        // console.log(timeEn)
        // console.log(timeSt+'||'+timeEn+'||'+timeInt)
        this.$emit('setnewtime', timeSt, timeEn, timeInt)
      },
      deleteChart () {
        this.$emit('deleteChart', this.chartId)
      },
      duplicateChar () {
        this.$emit('duplicateChart', this.slice)
      },
      action () {
        this.$emit('actionToChart')
      }
    },
    watch: {
      startTime: {
        handler: function (startTime) {
          if (this.user_index === undefined) {
            this.user_index = this.index_now
          }
          this.interval = this.intervalTimeBar === 'auto'
            ? this.interval
            : this.intervalTimeBar
          this.options = {}
          this.initChart()
        }
      },
      endTime: {
        handler: function (endTime) {
          if (this.user_index === undefined) {
            this.user_index = this.index_now
          }
          this.interval = this.intervalTimeBar === 'auto'
            ? this.interval
            : this.intervalTimeBar
          this.options = {}
          this.initChart()
        }
      },
      stores: {
        handler: function (stores) {
          if (this.user_index === undefined) {
            this.user_index = this.index_now
          }
          this.interval = this.intervalTimeBar === 'auto'
            ? this.interval
            : this.intervalTimeBar
          this.options = {}
          this.initChart()
        }
      },
      text: {
        handler: function (text) {
          if (this.user_index === undefined) {
            this.user_index = this.index_now
          }
          this.interval = this.intervalTimeBar === 'auto'
            ? this.interval
            : this.intervalTimeBar
          this.options = {}
          this.initChart()
        }
      },
      user_index: {
        handler: function (user_index) {
          if (this.user_index) {
            this.interval = this.intervalTimeBar === 'auto'
              ? this.interval
              : this.intervalTimeBar
            this.options = {}
            this.initChart()
          }
        },
        index_now: {
          handler: function (user_index) {
            this.user_index = this.index_now
          }
        }
      },
      reloadchart: {
        handler: function (val) {
          this.options = {}
          this.initChart()
        }
      }
    }
}
</script>

<style scoped>
/* .chart {
  min-height: 250px
} */
</style>



// WEBPACK FOOTER //
// src/components/x-timeBar.vue